// SolutionsCattle.js
import React from 'react';
import Warehouse from '../resorcesfiles/ideak/Warehouse.png'; // Importing image as provided
import Mainmastet from '../masterpage/Mainmastet';
import Cattle1 from '../resorcesfiles/ideak/cattle1.jpg'; // Importing image as provided
import Cattle2 from '../resorcesfiles/ideak/cattle2.jpg'; // Importing image as provided
import Cattle3 from '../resorcesfiles/ideak/cattle3.jpg'; // Importing image as provided

const SolutionsCattle = () => {
  return (
    <Mainmastet content={<>
    
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Cattle record keeping has never been easier</h1>
      <p>
        CattleOs provides record-keeping software to help you manage and run your cattle operation.
        CattleOs helps you prevent unnecessary cattle loss and improve profitability across your entire
        operation. By integrating software with RFID tags and hardware, you will digitally transform
        your cattle business with our One-Stop traceability Solution Platform.
      </p>
      <p>
        RFID tags are small “button-like” tags that are placed in the ear. Each RFID tag has a unique
        number printed on it, and the number can also be read by scanning the tag with an RFID reader.
        These tags are designed to last for the life of the animal.
      </p>
      <h2>Using Electronic RFID tags has many advantages:</h2>
      <ul>
        <li>
          It offers another form of identification for each animal. Sometimes visual tags get lost, become
          snagged on a fence, etc., whereas RFID tags are small and are designed for high retention rates.
        </li>
        <li>
          An animal can more quickly be identified in the chute (by scanning the tag with a reader) rather
          than needing to have the animal be completely still to read a visual tag or tattoo number.
        </li>
        <li>
          Scanning RFID tags, instead of manually writing down an ear tag number, offers tremendous
          time-saving benefits while minimizing errors. As cattle are being worked or loaded into a trailer,
          their RFID tag can be scanned while they are on the move.
        </li>
      </ul>
      <h2>RFID Glass Tag</h2>
      <p>
        RFID Glass Tag is a passive and reliable tag used for the identification of livestock, pets, birds,
        fish, and laboratory animals for health record-keeping, insurance, identification, slaughterhouses,
        and general tracking. It is a flexible solution as it offers secure animal identification that
        withstands most chemicals and harsh environments. Our livestock glass tag is equipped with a
        microchip and is made of biocompatible glass. It is implanted under the skin of the animal with the
        help of an injectable applicator and provides an adequate reading range to detect livestock from a
        considerable distance. The glass tag is a reliable solution for secure authentication as the tag is
        under the skin. The RFID Glass Animal Tracking & Identification tag is available in 134.2 KHz, UHF
        and HF, and various sizes.
      </p>
      <img src={Cattle1} alt="RFID Glass Tag" style={{ width: '300px', margin: '20px 0' }} />

      <h2>RFID Ear Animal Tags</h2>
      <p>
        RFID Ear animal tags are passively operated for the identification of livestock, health record
        keeping, insurance, and slaughterhouse. These tags consist of a male and a female part, and they are
        clamped together in the ear. Printing and encoding of these tags are also available for easy
        implementation. These tags help dairy owners and breeders manage their livestock more efficiently.
        Also, vaccination and other health details are mapped against UID.
      </p>
      <div style={{display:'flex',flexDirection:"row"}}>
      <img src={Cattle2} alt="RFID Ear Animal Tags" style={{ width: '300px', margin: '20px 0' }} />
      <img src={Cattle3} alt="RFID Ear Animal Tags" style={{ width: '300px', margin: '20px 0' }} />
      </div>
    </div>
    
    </>} />
  );
};

export default SolutionsCattle;
